module.exports = __webpack_public_path__ + "media/images/common/more-arrow-c2d6cf50a51fdb8d2319c7a6a3e0bc8c.svg";